import React from 'react';
import { Box } from '@styleseat/ui';
import { Touchable } from '../../../ui';
import ShareArrowIcon from '../ShareArrowIcon';

export const BasicShareArrowButton: React.FCWithChildren<{
  onClick: () => void;
}> = ({
  onClick,
}) => (
  <Touchable onClick={onClick} accessibilityRole="button" testID="basic-share-arrow-button">
    <Box
      alignItems="center"
      minHeight={24}
      maxHeight={24}
    >
      <ShareArrowIcon />
    </Box>
  </Touchable>
);
